var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ui-chip",
    {
      staticClass: "md-deletable",
      class: { "md-accent": _vm.isHovering },
      attrs: {
        clickable: _vm.clickable,
        disabled: _vm.disabled,
        tooltip: _vm.tooltip,
      },
      on: {
        click: function ($event) {
          !_vm.disabled && _vm.$emit("click", _vm.uri)
        },
        mouseenter: function ($event) {
          _vm.isHovering = true
        },
        mouseleave: function ($event) {
          _vm.isHovering = false
        },
      },
    },
    [
      _c("span", { staticClass: "ui-chip__record-icon fas fa-circle" }),
      _vm._v("\n\t" + _vm._s(_vm.name || _vm.uri) + "\n\t"),
      _c("ui-button", {
        staticClass: "md-input-action",
        attrs: { dense: "", icon: "fa fa-pencil" },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.$emit("edit", _vm.uri)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }